const Photo = ({ color, type }) => {
  const regular = (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.24002 5.19995C5.24002 4.09538 6.13546 3.19995 7.24002 3.19995H20.6C21.7046 3.19995 22.6 4.09538 22.6 5.19995V15.2C22.6 16.3045 21.7046 17.2 20.6 17.2H7.24003C6.13546 17.2 5.24002 16.3045 5.24002 15.2V5.19995ZM20.6 5.19995L7.24002 5.19995V15.2H7.24323C7.29596 15.0789 7.37366 14.9664 7.47608 14.8704L11.3161 11.2704C11.6618 10.9463 12.1875 10.9094 12.5752 11.1819L14.45 12.5001L17.4822 9.49024C17.8642 9.11101 18.4779 9.10225 18.8706 9.47041L20.6 11.0917L20.6 5.19995ZM20.6 13.8332L18.2065 11.5893L15.2645 14.5097C14.9206 14.8511 14.3813 14.8967 13.9848 14.618L12.0904 13.2859L10.0488 15.2L20.6 15.2V13.8332ZM10.08 6.70972C10.6323 6.70972 11.08 7.15743 11.08 7.70972V7.79995C11.08 8.35224 10.6323 8.79995 10.08 8.79995C9.52774 8.79995 9.08002 8.35224 9.08002 7.79995V7.70972C9.08002 7.15743 9.52774 6.70972 10.08 6.70972ZM2.40002 7.99995C2.95231 7.99995 3.40002 8.44767 3.40002 8.99995V18.8H15.2C15.7523 18.8 16.2 19.2477 16.2 19.7999C16.2 20.3522 15.7523 20.7999 15.2 20.7999H2.40002C1.84774 20.7999 1.40002 20.3522 1.40002 19.7999V8.99995C1.40002 8.44767 1.84774 7.99995 2.40002 7.99995Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Photo;
